import { render, staticRenderFns } from "./generalBreakPosDetailModal.vue?vue&type=template&id=f660ac54&"
import script from "./generalBreakPosDetailModal.vue?vue&type=script&lang=js&"
export * from "./generalBreakPosDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports